<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      previewFlag: false,
    }
  },
  props:{
    value: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    filterImageUrl: function() {
      return this.imageUrl.includes('http') ? this.imageUrl : this.$server.qxyRes + this.imageUrl
    }
  },
  watch: {
    value: function(val) {
      this.previewFlag = this.value
      if (val) {
        this.previewImage()
      }
    },
    previewFlag: function(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    previewImage: function() {
      setTimeout(() => {
        this.previewFlag = false
      }, 1000)
      let list = [this.filterImageUrl]
      this.$viewerApi({
        images: list
      })
    }
  },
}
</script>


<style scoped>

</style>